"use strict";

var __extends = this && this.__extends || function () {
  var _n = function n(e, t) {
    return (_n = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var r in t) {
        t.hasOwnProperty(r) && (e[r] = t[r]);
      }
    })(e, t);
  };

  return function (e, t) {
    function r() {
      this.constructor = e;
    }

    _n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
  };
}(),
    __assign = this && this.__assign || function () {
  return (__assign = Object.assign || function (e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      for (var o in t = arguments[r]) {
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
      }
    }

    return e;
  }).apply(this, arguments);
},
    __spreadArrays = this && this.__spreadArrays || function () {
  for (var e = 0, t = 0, r = arguments.length; t < r; t++) {
    e += arguments[t].length;
  }

  var n = Array(e),
      o = 0;

  for (t = 0; t < r; t++) {
    for (var s = arguments[t], i = 0, u = s.length; i < u; i++, o++) {
      n[o] = s[i];
    }
  }

  return n;
};

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var React = require("react"),
    ignoreForTagNames = ["input"],
    defaultState = {
  shortcuts: []
},
    ShortcutContext = React.createContext(defaultState);

exports.ShortcutConsumer = ShortcutContext.Consumer;

var ShortcutProvider = function (e) {
  function h() {
    var y = null !== e && e.apply(this, arguments) || this;
    return y.holdDurations = {}, y.holdListeners = {}, y.holdTimer = 0, y.keysDown = [], y.listeners = {}, y.previousKeys = [], y.sequenceListeners = {}, y.shortcuts = [], y.state = {
      shortcuts: []
    }, y.createTimer = function (e) {
      y.holdInterval = window.setInterval(function () {
        e(), y.holdTimer += 100;
      }, 100);
    }, y.keyDown = function (t) {
      var e,
          r,
          n = y.props,
          o = n.ignoreKeys,
          s = void 0 === o ? [] : o,
          i = n.ignoreTagNames,
          u = n.preventDefault,
          a = void 0 === u || u,
          c = t.target,
          h = i ? __spreadArrays(i.map(function (e) {
        return e.toLowerCase();
      }), ignoreForTagNames) : ignoreForTagNames,
          l = null === (r = t.key) || void 0 === r ? void 0 : r.toLowerCase();

      if (l && h.indexOf(c.tagName.toLowerCase()) < 0 && y.keysDown.indexOf(l) < 0) {
        var d = [],
            f = [];
        ("control" === l || !0 === t.ctrlKey) && s.indexOf("ctrl") < 0 && (y.keysDown.indexOf("ctrl") < 0 && d.push("ctrl"), "control" === l && f.push(l)), ("alt" === l || !0 === t.altKey) && s.indexOf("alt") < 0 && (y.keysDown.indexOf("alt") < 0 && d.push("alt"), "alt" === l && f.push(l)), ("meta" === l || !0 === t.metaKey) && s.indexOf("meta") < 0 && s.indexOf("cmd") < 0 && (y.keysDown.indexOf("meta") < 0 && d.push("meta"), "meta" === l && f.push(l)), ("shift" === l || !0 === t.shiftKey) && s.indexOf("shift") < 0 && (y.keysDown.indexOf("shift") < 0 && d.push("shift"), "shift" === l && f.push(l)), __spreadArrays(s, f).indexOf(l) < 0 && d.push(l), y.keysDown = __spreadArrays(y.keysDown, d);
        var p = y.keysDown.join("+");
        y.listeners[p] && (a && t.preventDefault(), y.listeners[p].forEach(function (e) {
          return e(t);
        })), y.resetTimer(), y.createTimer(function () {
          d.forEach(function (e) {
            y.holdTimer >= y.holdDurations[e] && (y.holdListeners[p](t), y.resetTimer());
          });
        }), void 0 !== y.sequenceTimer && window.clearTimeout(y.sequenceTimer), (e = y.previousKeys).push.apply(e, d);
        var v = y.previousKeys.join(",");
        void 0 !== y.sequenceListeners[v] && (y.sequenceListeners[v](t), y.sequenceTimer && (window.clearTimeout(y.sequenceTimer), y.sequenceTimer = void 0, y.previousKeys = [])), y.sequenceTimer = window.setTimeout(function () {
          y.previousKeys = [], y.sequenceTimer = void 0;
        }, 2e3);
      }
    }, y.keyUp = function (e) {
      var t,
          r = [],
          n = null === (t = e.key) || void 0 === t ? void 0 : t.toLowerCase();
      "control" !== n && !0 !== e.ctrlKey || r.push("ctrl"), "alt" !== n && !0 !== e.altKey || r.push("alt"), "meta" !== n && !0 !== e.metaKey || r.push("meta"), "shift" !== n && !0 !== e.shiftKey || r.push("shift");
      ["control", "alt", "meta", "shift"].indexOf(n) < 0 && r.push(n), y.keysDown = y.keysDown.filter(function (e) {
        return r.indexOf(e) < 0;
      }), y.resetTimer();
    }, y.windowBlur = function (e) {
      y.keysDown = [], y.resetTimer();
    }, y.registerShortcut = function (t, e, r, n, o) {
      void 0 === e && (e = []);

      var s = __spreadArrays(y.shortcuts),
          i = void 0 !== o,
          u = void 0 !== o ? o : 0,
          a = h.transformKeys(e),
          c = {
        id: Date.now().toString(36),
        description: n,
        hold: i,
        holdDuration: u,
        keys: a,
        method: t,
        sequence: !1,
        title: r
      };

      s.push(c), a.forEach(function (e) {
        i ? (y.holdDurations[e] = u, y.holdListeners[e] = t) : (y.listeners[e] || (y.listeners[e] = []), y.listeners[e] = __spreadArrays(y.listeners[e], [t]));
      }), y.shortcuts = s, y.setState({
        shortcuts: s
      });
    }, y.registerSequenceShortcut = function (e, t, r, n) {
      void 0 === t && (t = []);

      var o = __spreadArrays(y.shortcuts),
          s = {
        id: Date.now().toString(36),
        description: n,
        hold: !1,
        holdDuration: 0,
        keys: t,
        method: e,
        sequence: !0,
        title: r
      },
          i = !1,
          u = t.join(",").toLowerCase();

      Object.keys(y.sequenceListeners).forEach(function (e) {
        i = i || u === e;
      }), i || (o.push(s), y.sequenceListeners[u] = e, y.shortcuts = o, y.setState({
        shortcuts: o
      }));
    }, y.resetTimer = function () {
      void 0 !== y.holdInterval && (window.clearInterval(y.holdInterval), y.holdInterval = void 0, y.holdTimer = 0);
    }, y.triggerShortcut = function (e) {
      var t = h.transformKeys([e]).pop();
      t && y.listeners[t] && y.listeners[t].forEach(function (e) {
        return e();
      });
    }, y.unregisterShortcut = function (e, t) {
      void 0 === t && (t = !1);
      var n = h.transformKeys(e);

      if (t) {
        var r = n.join(",");
        delete y.sequenceListeners[r];
      } else n.forEach(function (e) {
        y.listeners[e] && (y.listeners[e].pop(), 0 === y.listeners[e].length && delete y.listeners[e]), delete y.holdListeners[e], delete y.holdDurations[e];
      });

      var o = y.shortcuts.filter(function (e) {
        var t = e.keys,
            r = !0;
        return t.forEach(function (e) {
          r = r && 0 <= n.indexOf(e);
        }), !r;
      });
      y.shortcuts = o, y.setState({
        shortcuts: o
      });
    }, y;
  }

  return __extends(h, e), h.prototype.componentDidMount = function () {
    window.addEventListener("keydown", this.keyDown), window.addEventListener("keyup", this.keyUp), window.addEventListener("blur", this.windowBlur);
  }, h.prototype.componentWillUnmount = function () {
    window.removeEventListener("keydown", this.keyDown), window.removeEventListener("keyup", this.keyUp), window.removeEventListener("blur", this.windowBlur);
  }, h.prototype.render = function () {
    var e = this.state.shortcuts,
        t = this.props.children,
        r = {
      registerSequenceShortcut: this.registerSequenceShortcut,
      registerShortcut: this.registerShortcut,
      shortcuts: e,
      triggerShortcut: this.triggerShortcut,
      unregisterShortcut: this.unregisterShortcut
    };
    return React.createElement(ShortcutContext.Provider, {
      value: r
    }, t);
  }, h.transformKeys = function (e) {
    return e.map(function (e) {
      return ("" + e).split("+").map(function (e) {
        var t = e.toLowerCase();

        switch (t) {
          case "opt":
          case "option":
            return "alt";

          case "control":
            return "ctrl";

          case "cmd":
          case "command":
            return "meta";

          default:
            return t;
        }
      }).join("+");
    });
  }, h;
}(React.PureComponent);

exports.ShortcutProvider = ShortcutProvider, exports.withShortcut = function (r) {
  return t = React.Component, __extends(e, t), e.prototype.render = function () {
    var t = this;
    return React.createElement(exports.ShortcutConsumer, null, function (e) {
      return React.createElement(r, __assign({}, t.props, {
        shortcut: e
      }));
    });
  }, e;

  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  var t;
};